(() => {
  const pauseOtherMedia = active => document.querySelectorAll('audio, video').forEach(media => { if (media !== active) media.pause(); });
  const clock = seconds => `${Math.floor((seconds || 0) / 60)}:${String(Math.floor((seconds || 0) % 60)).padStart(2, '0')}`;
  const initialize = root => {
    root.querySelectorAll('[data-audio-demo]').forEach(player => {
      if (player.dataset.initialized) return;
      player.dataset.initialized = 'true';
      const tracks = Object.fromEntries([...player.querySelectorAll('[data-demo-audio]')].map(audio => [audio.dataset.demoAudio, audio]));
      const play = player.querySelector('[data-demo-play]');
      const seek = player.querySelector('[data-demo-seek]');
      const time = player.querySelector('[data-demo-time]');
      const status = player.querySelector('[data-demo-status]');
      let mode = 'before';
      let revision = 0;
      let playRevision = 0;
      const selected = () => tracks[mode];
      const update = () => {
        const audio = selected();
        const duration = Number.isFinite(audio.duration) ? audio.duration : Number(player.dataset.duration || 0);
        seek.max = duration;
        seek.disabled = !duration;
        player.querySelector('[data-demo-length]').textContent = duration ? clock(duration) : ''; 
        seek.value = audio.currentTime;
        time.textContent = `${clock(audio.currentTime)} / ${duration ? clock(duration) : '—'}`;
        player.style.setProperty('--progress', `${duration ? audio.currentTime / duration * 100 : 0}%`);
        player.querySelector('[data-play-icon]').textContent = audio.paused ? '▶' : 'Ⅱ';
        play.setAttribute('aria-label', `${audio.paused ? player.dataset.playLabel : player.dataset.pauseLabel}: ${player.querySelector('h3').textContent}`);
      };
      const ready = audio => audio.readyState >= 1 ? Promise.resolve() : new Promise((resolve, reject) => {
        audio.addEventListener('loadedmetadata', resolve, { once: true });
        audio.addEventListener('error', reject, { once: true });
        audio.load();
      });
      const start = async audio => {
        const request = ++playRevision;
        status.textContent = '';
        pauseOtherMedia(audio);
        try { await audio.play(); } catch (error) { if (request === playRevision && error.name !== 'AbortError') status.textContent = player.dataset.errorLabel; }
      };
      play.addEventListener('click', () => { const audio = selected(); if (audio.paused) start(audio); else { playRevision++; audio.pause(); } });
      player.querySelectorAll('[data-demo-mode]').forEach(button => button.addEventListener('click', async () => {
        if (mode === button.dataset.demoMode) return;
        const previous = selected();
        const position = previous.currentTime;
        const wasPlaying = !previous.paused;
        previous.pause();
        mode = button.dataset.demoMode;
        const request = ++revision;
        player.querySelectorAll('[data-demo-mode]').forEach(toggle => toggle.setAttribute('aria-pressed', String(toggle === button)));
        update();
        const next = selected();
        try { await ready(next); if (request !== revision) return; next.currentTime = Math.min(position, next.duration || position); update(); if (wasPlaying) start(next); }
        catch { if (request === revision) status.textContent = player.dataset.errorLabel; }
      }));
      seek.addEventListener('input', async () => { const audio = selected(); const position = Number(seek.value); try { await ready(audio); if (audio === selected()) { audio.currentTime = position; update(); } } catch { status.textContent = player.dataset.errorLabel; } });
      Object.values(tracks).forEach(audio => {
        ['timeupdate', 'loadedmetadata', 'pause', 'ended'].forEach(event => audio.addEventListener(event, update));
        audio.addEventListener('play', () => { pauseOtherMedia(audio); update(); });
        audio.addEventListener('error', () => { status.textContent = player.dataset.errorLabel; });
      });
      player.querySelector('.vocal-demo__controls').hidden = false;
      player.classList.add('is-enhanced');
      update();
    });
    root.querySelectorAll('video').forEach(video => { if (video.dataset.initialized) return; video.dataset.initialized = 'true'; video.addEventListener('play', () => pauseOtherMedia(video)); });
  };
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-play-trailer]')) return;
    const video = document.querySelector('#watch video');
    if (video) video.play().catch(() => {});
  });
  let dockObserver;
  const initializeDock = () => {
    dockObserver?.disconnect();
    const dock = document.querySelector('[data-purchase-dock]');
    const primary = document.querySelector('[data-primary-purchase]');
    if (dock && primary && 'IntersectionObserver' in window) {
      dockObserver = new IntersectionObserver(entries => { dock.hidden = entries[0].isIntersecting; }, { threshold:0.1 });
      dockObserver.observe(primary);
    }
  };
  initialize(document); initializeDock();
  document.addEventListener('shopify:section:load', event => { initialize(event.target); initializeDock(); });
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('audio, video').forEach(media => media.pause());
    if (event.target.querySelector('[data-primary-purchase]')) dockObserver?.disconnect();
  });
})();
